import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function FAQ() {
  const {
    t,
    lang
  } = useTranslations();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqsEs = [{
    question: '¿Brixen Funding es un banco o prestamista?',
    answer: 'No. Brixen Funding es un broker de financiamiento comercial. No prestamos dinero directamente; conectamos tu negocio con prestamistas según tu perfil.'
  }, {
    question: '¿Cuánto financiamiento puedo obtener?',
    answer: 'El monto depende de factores como ingresos, tiempo en el negocio y perfil crediticio. Algunos negocios califican desde $10,000 hasta $150,000 o más.'
  }, {
    question: '¿Aplicar afecta mi crédito?',
    answer: 'En la mayoría de los casos, la evaluación inicial no afecta tu crédito. Algunas opciones pueden requerir revisión crediticia más adelante.'
  }, {
    question: '¿Qué tan rápido puedo recibir los fondos?',
    answer: 'Muchas aprobaciones ocurren en 24 horas y algunos negocios reciben fondos el mismo día hábil, dependiendo del prestamista.'
  }, {
    question: '¿Puedo calificar con crédito bajo?',
    answer: 'Sí. Existen opciones de financiamiento basadas en ingresos donde el crédito no es el factor principal.'
  }, {
    question: '¿Necesito garantía personal?',
    answer: 'La mayoría de las opciones no requieren garantía personal, aunque depende del tipo de financiamiento y del prestamista.'
  }, {
    question: '¿Qué documentos necesito para aplicar?',
    answer: 'Generalmente se solicitan: estados de cuenta bancarios recientes, información básica del negocio e identificación del propietario.'
  }, {
    question: '¿Tiene algún costo aplicar?',
    answer: 'No. Aplicar es completamente gratis. Solo cobramos si obtienes financiamiento.'
  }, {
    question: '¿Trabajan con negocios nuevos?',
    answer: 'Sí. Algunos programas están disponibles para negocios con poco tiempo de operación, siempre que cumplan ciertos requisitos.'
  }, {
    question: '¿En qué tipo de negocios se especializan?',
    answer: 'Trabajamos con múltiples industrias: restaurantes, construcción, transporte, servicios, e-commerce y más.'
  }];
  const faqsEn = [{
    question: 'Is Brixen Funding a bank or lender?',
    answer: 'No. Brixen Funding is a commercial funding broker. We do not lend money directly; we connect your business with lenders based on your profile.'
  }, {
    question: 'How much funding can I get?',
    answer: 'The amount depends on factors like revenue, time in business, and credit profile. Some businesses qualify from $10,000 to $150,000 or more.'
  }, {
    question: 'Does applying affect my credit?',
    answer: 'In most cases, the initial evaluation does not affect your credit. Some options may require a credit check later.'
  }, {
    question: 'How fast can I receive the funds?',
    answer: 'Many approvals happen within 24 hours and some businesses receive funds the same business day, depending on the lender.'
  }, {
    question: 'Can I qualify with low credit?',
    answer: 'Yes. There are revenue-based funding options where credit is not the main factor.'
  }, {
    question: 'Do I need a personal guarantee?',
    answer: 'Most options do not require a personal guarantee, although it depends on the type of financing and the lender.'
  }, {
    question: 'What documents do I need to apply?',
    answer: 'Generally required: recent bank statements, basic business information, and owner identification.'
  }, {
    question: 'Is there a cost to apply?',
    answer: 'No. Applying is completely free. We only charge if you get funded.'
  }, {
    question: 'Do you work with new businesses?',
    answer: 'Yes. Some programs are available for businesses with little time in operation, as long as they meet certain requirements.'
  }, {
    question: 'What types of businesses do you specialize in?',
    answer: 'We work with multiple industries: restaurants, construction, transportation, services, e-commerce, and more.'
  }];
  const faqs = lang === 'es' ? faqsEs : faqsEn;
  return <section id="faq" className="py-20 bg-white" data-id="element-116">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="text-center mb-12" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-119">
            {t('faq.title')}{' '}
            <span className="text-[#00E676]" data-id="element-120">{t('faq.titleHighlight')}</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-121">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-122">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-123">
                <span className="font-semibold text-gray-900 pr-4" data-id="element-124">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#00E676] flex-shrink-0" data-id="element-125" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-126" />}
              </button>
              {openIndex === index && <div className="px-6 pb-4 bg-gray-50" data-id="element-127">
                  <p className="text-gray-600 leading-relaxed" data-id="element-128">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}